import { IProductCatalog, PromotionType } from '../graphQL/commons'
import { IPromotion } from '../interfaces'

export const deleteExcludedPromotionTypes = (
  promotions: IProductCatalog['promotions'],
  promotionsToExclude: PromotionType[],
): IPromotion[] =>
  promotions?.filter(({ type }) => promotionsToExclude.indexOf(type) < 0) || []
